import { render, staticRenderFns } from "./introduce-business.vue?vue&type=template&id=5466e1be&scoped=true"
import script from "./introduce-business.vue?vue&type=script&lang=js"
export * from "./introduce-business.vue?vue&type=script&lang=js"
import style0 from "./introduce-business.vue?vue&type=style&index=0&id=5466e1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466e1be",
  null
  
)

export default component.exports